// Sticky section pills: pin under the header and highlight the section in view.
(function () {
  var jump = document.querySelector('[data-jump]');
  if (!jump) return;
  var header = document.querySelector('.site-header');
  function setTop() {
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--jump-top', h + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop);

  var chips = jump.querySelectorAll('.chip');
  if (!('IntersectionObserver' in window) || !chips.length) return;
  var byId = {};
  chips.forEach(function (c) { byId[c.getAttribute('href').slice(1)] = c; });
  var row = jump.querySelector('.jump__list');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var c = byId[en.target.id];
      if (!c) return;
      chips.forEach(function (x) { x.classList.remove('is-current'); x.removeAttribute('aria-current'); });
      c.classList.add('is-current');
      c.setAttribute('aria-current', 'true');
      if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: c.offsetLeft - 16, behavior: 'smooth' });
    });
  }, { rootMargin: '-35% 0px -60% 0px' });
  Object.keys(byId).forEach(function (id) {
    var el = document.getElementById(id);
    if (el) io.observe(el);
  });
})();

// Close the phone menu after a section link is tapped.
(function () {
  var nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  nav.addEventListener('click', function (e) {
    if (e.target.closest('a')) nav.removeAttribute('open');
  });
})();

// Contact form niceties. The form works without this file.
(function () {
  var form = document.getElementById('contact-form');
  if (!form) return;

  var nameField = form.querySelector('[data-name-field]');
  var sendButton = form.querySelector('[data-send]');

  form.addEventListener('submit', function () {
    try {
      if (nameField) sessionStorage.setItem('btb-name', nameField.value.trim().split(' ')[0]);
    } catch (e) {}
    if (sendButton) {
      sendButton.textContent = 'Sending...';
      sendButton.setAttribute('aria-disabled', 'true');
    }
  });

  var confirm = form.querySelector('[data-confirm]');
  if (!confirm) return;

  try {
    var name = sessionStorage.getItem('btb-name');
    var slot = confirm.querySelector('[data-confirm-name]');
    if (name && slot) slot.textContent = ', ' + name;
  } catch (e) {}

  confirm.scrollIntoView({ block: 'center' });
  confirm.focus({ preventScroll: true });
})();
